import { TeamRole, teamRoleLabel } from '@/consts/team'

export type MemberStatus = 'uninitialized' | 'suspended' | 'inactive' | 'deleted' | 'active'

export const TEAM_ROLE_OPTIONS: Array<{ value: TeamRole; label: string }> = [
  { value: TeamRole.Normal, label: teamRoleLabel[TeamRole.Normal] },
  { value: TeamRole.Admin, label: teamRoleLabel[TeamRole.Admin] },
  // { value: TeamRole.Owner, label: teamRoleLabel[TeamRole.Owner] },
]

export type AddMemberForm = {
  account: string
  accountUserName: string
  password: string
  role: TeamRole
  assignCredit: number
  alias?: string
  note?: string
}

export type NewMemberResult = {
  id: string
  account: string
  accountUserName: string
  role: TeamRole
  credits: number
  password: string
}
